import * as React from 'react'
import './styles.css'
import BookADemoButton from '../../ui/BookADemoButton'

const StrategicClarityCTA = () => {
  return (
    <section className='overview-section strategic-clarity-cta-section'>
      <div className='box'>
        <div className='strategic-clarity-cta-content'>
          <h2 className='strategic-clarity-cta-title'>
            Turn Workforce Complexity Into Strategic Clarity
          </h2>
          <p className='strategic-clarity-cta-description'>
            See how Pod transforms fragmented workforce data into real-time
            intelligence for enterprise, government, and mission-critical
            organizations.
          </p>
          <div className='strategic-clarity-cta-button-wrap'>
            <BookADemoButton label='Request an Intelligence Demo' />
          </div>
        </div>
      </div>
    </section>
  )
}

export default StrategicClarityCTA
